
customElements.define('gwp-logic', class GWPLogic extends HTMLElement {
  constructor() {
    super();

    this.gwpLogics = []
    this.flickity = null
  }

  connectedCallback () {
    this.itemsContainer = this.querySelector('.js-gwp-items')

    this.validateGWPLogics()

    document.addEventListener('rebuy:cart.change', this.validateGWPLogics.bind(this))
  }

  mapGWPScenarios (cartItems) {
    this.gwpLogics = window.gwpLogic.map(logic => {
      if (logic.type === 'gwp_buy_x_get_y') {
        const validQty = cartItems.filter(item => item.variant_id === logic.scenario.buy_x_variant.id)
          .filter(item => item.properties?._gwp !== logic.id)
          .map(item => item.quantity)
          .reduce((a, b) => a + b, 0)

        return {
          type: logic.type,
          id: logic.id,
          items: logic.scenario.get_y_items,
          quantity: logic.scenario.get_y_quantity,
          valid: validQty >= logic.scenario.required_quantity,
          requiredItem: logic.scenario.buy_x_variant
        }
      }

      if (logic.type === 'gwp_by_number') {
        const validQty = cartItems.filter(item => !(logic?.scenario?.sku_to_exclude || []).includes(item.sku))
          .filter(item => item.properties?._gwp !== logic.id)
          .map(item => item.quantity)
          .reduce((a, b) => a + b, 0)

        return {
          type: logic.type,
          id: logic.id,
          items: logic.scenario.get_y_items,
          quantity: logic.scenario.get_y_quantity,
          valid: validQty >= logic.scenario.required_quantity
        }
      }

      if (logic.type === 'gwp_by_amount') {
        const validAmount = cartItems.filter(item => !(logic?.scenario?.sku_to_exclude || []).includes(item.sku))
          .map(item => item.line_price)
          .reduce((a, b) => a + b, 0)

        return {
          type: logic.type,
          id: logic.id,
          items: logic.scenario.get_y_items,
          quantity: logic.scenario.get_y_quantity,
          valid: validAmount >= logic.scenario.required_cart_amount
        }
      }
    }).filter(item => !!item)
  }

  async validateGWPLogics() {
    const cartItems = window.Rebuy.Cart.items()

    if (localStorage.getItem('gwp-busy')) return;

    localStorage.setItem('gwp-busy', true)

    this.mapGWPScenarios(cartItems)

    const inEligibleItems = cartItems.filter(item => !!item.properties?._gwp)
      .filter(item => {
        const logic = this.gwpLogics.find(e => {
          return e.id === item.properties?._gwp && e.items.map(el => el.id).includes(item.variant_id)
        })

        return !logic?.valid
      })

    if (inEligibleItems.length > 0) {
      let updates = {}
      inEligibleItems.map(item => updates[item.key] = 0)

      await window.Rebuy.Cart.updateItem({ updates })
    }

    let autoAddItems = this.gwpLogics.filter(logic => logic.items.length === 1 && logic.valid)
      .flatMap(logic => logic.items.map(item => {
        let quantity = logic.quantity
        if (logic.type === 'gwp_buy_x_get_y') {
          const requiredItemsInCart = cartItems.filter(item => item.variant_id === logic.requiredItem.id)
            .map(item => item.quantity)
            .reduce((a, b) => a + b, 0)

          quantity = Math.min(requiredItemsInCart, quantity)
        }

        return {
          id: item.id,
          quantity,
          type: logic.type,
          gwpId: logic.id,
          requiredItem: logic.requiredItem
        }
      }))

    if (autoAddItems.length > 0) {
      let updates = {}

      autoAddItems.map(item => {
        const itemInCart = cartItems.find(line => line.variant_id === item.id && item.type === line.properties?._gwp_type)

        if (!!itemInCart && item.quantity !== itemInCart?.quantity) {
          if (item.type === 'gwp_buy_x_get_y') {
            updates[itemInCart.key] = item.quantity
          }
        }
      })

      if (Object.keys(updates).length > 0) await window.Rebuy.Cart.updateItem({ updates })
    }

    autoAddItems = autoAddItems.filter(item => !cartItems.find(line => line.variant_id === item.id && item.type === line.properties?._gwp_type))
      .map(item => ({
        id: item.id,
        quantity: item.quantity,
        properties: {
          _gwp: item.gwpId,
          _gwp_type: item.type
        }
      }))

    if (autoAddItems.length > 0) {
      await window.Rebuy.Cart.addItem({ items: autoAddItems })
    }

    this.renderSnippet()
  }

  renderSnippet () {
    const html = this.gwpLogics.filter(logic => logic.items.length > 1)
    .map(logic => {
      const itemsById = Object.groupBy(logic.items, ({ product_id }) => product_id)
      let quantity = logic.quantity

      if (logic.type === 'gwp_buy_x_get_y') {
        const requiredItemsInCart = window.Rebuy.Cart.items().filter(item => item.variant_id === logic.requiredItem.id)
            .map(item => item.quantity)
            .reduce((a, b) => a + b, 0)

        quantity = Math.min(requiredItemsInCart, quantity)
      }

      return Object.keys(itemsById).map(productId => {
        const items = itemsById[productId]
        const defaultItem = items[0]
        console.log(logic)

        const cartItem = window.Rebuy.Cart.items().find(lineItem => {
          return +lineItem.properties?._gwp === +logic.id && lineItem.variant_id === defaultItem.id
        })

        return `
          <gwp-item>
            <div class="gwp-item ${logic.valid ? '' : 'disabled'}" data-id="${defaultItem.id}">
              <div class="gwp-item__media">
                <div class=" media media--square media--image-contain">
                  <img src="${defaultItem.image}" class="js-thumbnail-image">
                </div>
              </div>
              <div class="gwp-item__info">
                <div>
                  <h4 class="gwp-item__title">${defaultItem.product_title}</h4>
                  <p class="gwp-item__subtitle js-variant-title">${defaultItem.variant_title}</p>
                </div>
                ${
                  items.length > 1 ?
                  `<ul class="gwp-item__variants">
                    ${items.map(item => {
                      return `<li>
                        <button
                          type="button"
                          class="gwp-item-variant ${!!item.color_swatch_fallback ? 'gwp-item-swatch' : ''} ${item.id === defaultItem.id ? 'selected' : ''} js-variant"
                          style="${item.swatch_style}"
                          data-id="${item.id}"
                          data-gwp-id="${logic.id}"
                          data-image="${item.image}"
                          data-title="${item.variant_title}"
                        >${item.title}</button>
                      </li>`
                      }).join('')}
                  </ul>
                  ` : ''
                }
                <gwp-item-action>
                  ${logic.valid ?
                    `<button
                      class="gwp-item__add js-gwp-action ${!!cartItem ? '' : 'js-add'}"
                      data-id="${defaultItem.id}"
                      data-gwp-id="${logic.id}"
                      data-type="${logic.type}"
                      data-quantity="${quantity}"
                      type="button"
                    >${!!cartItem ? 'Added' : 'Add'}</button>`:
                    `<p class="caption-large light">Cart requirement not met</p>`
                  }
                </gwp-item-action>
              </div>
            </div>
          </gwp-item>
        `
      }).join('')
    }).join('')

    const gwpItemsCount = this.gwpLogics.filter(logic => logic.items.length > 1)
      .map(logic => logic.items.length)
      .reduce((a, b) => a + b, 0)

    this.classList[gwpItemsCount === 0 ? 'add' : 'remove']('hidden')

    if (!!this.flickity) {
      this.flickity.destroy()
    }

    this.itemsContainer.innerHTML = html

    this.flickity = new Flickity(this.itemsContainer, {
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      prevNextButtons: gwpItemsCount > 1
    });

    localStorage.removeItem('gwp-busy')
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'))
    }, 500)
  }
});

if (!customElements.get('gwp-item')) {
  customElements.define('gwp-item', class GWPItem extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback () {
      this.thumbnailImage = this.querySelector('.js-thumbnail-image')
      this.variantButtons = this.querySelectorAll('.js-variant')
      this.gwpAction = this.querySelector('gwp-item-action')

      this.variantButtons.forEach(button => button.addEventListener('click', this.handleSwatchClick.bind(this)))
    }

    handleSwatchClick (e) {
      const button = e.target.closest('.js-variant')

      const { id, image, title, gwpId } = button.dataset

      this.thumbnailImage.setAttribute('src', image)
      this.querySelector('.js-variant-title').innerHTML = title

      this.variantButtons.forEach(el => el.classList[el.dataset.id === id ? 'add' : 'remove']('selected'))

      if (!!this.querySelector('.js-gwp-action')) {
        this.querySelector('.js-gwp-action').setAttribute('data-id', id)
      }

      const cartItem = window.Rebuy.Cart.items().find(lineItem => {
        return +lineItem.properties?._gwp === +gwpId && +lineItem.variant_id === +id
      })

      if (!!cartItem) {
        this.querySelector('.js-gwp-action').setAttribute('disabled', '')
        this.querySelector('.js-gwp-action').innerHTML = 'Added'
      } else {
        this.querySelector('.js-gwp-action').removeAttribute('disabled')
        this.querySelector('.js-gwp-action').innerHTML = 'Add'
      }
    }
  })
}


if (!customElements.get('gwp-item-action')) {
  customElements.define('gwp-item-action', class GWPItemAction extends HTMLElement {
    constructor() {
      super();

      this.addButton = this.querySelector('.js-add')
    }

    connectedCallback () {
      this.addButton?.addEventListener('click', this.onAddClick.bind(this))
    }

    async onAddClick (e) {
      e.preventDefault()
      e.stopImmediatePropagation()

      const { id, type, quantity, gwpId } = this.addButton.dataset

      this.addButton.setAttribute('disabled', true)
      this.addButton.innerHTML = 'Adding'

      const cartItems = window.Rebuy.Cart.items()
      const gwpInCart = cartItems.filter(item => item?.properties?._gwp === gwpId)

      // Logic for GWP total Qty
      if (gwpInCart.length >= parseInt(quantity)) {
        let updates = {}
        gwpInCart.slice(-1).map(item => updates[item.key] = 0)

        await window.Rebuy.Cart.updateItem({ updates })
      }

      await window.Rebuy.Cart.addItem({
        id: id,
        quantity: 1,
        properties: {
          _gwp: gwpId,
          _gwp_type: type
        }
      })


      /* Logic for GWP Individual Quantity
      if (gwpInCart.length > 0) {
        let updates = {}
        gwpInCart.map(item => updates[item.key] = 0)

        await window.Rebuy.Cart.updateItem({ updates })
      }

      await window.Rebuy.Cart.addItem({
        id: id,
        quantity,
        properties: {
          _gwp: gwpId,
          _gwp_type: type
        }
      })
      */

      this.addButton.removeAttribute('disabled')
      this.addButton.innerHTML = 'Added'
    }
  })
}
